import React from "react";

const HowItWorksSection = ({ t, language }) => (
  <section className="how-it-works dark-gradient-section anim-section home-section" id="como-funciona">
    <div className="home-container">
      <div className="section-head">
        <h2>{t.steps.head}</h2>
        <p>{t.steps.sub}</p>
      </div>
      <div className="steps-grid">
        <div className="step-card card-animated anim-card">
          <span className="step-index">01</span>
          <h3>
            {language === "es" ? "Conectas dispositivos o app móvil" : "Connect devices or mobile app"}
          </h3>
          <p>
            {language === "es"
              ? "Integra trackers, app o sensores con un onboarding guiado."
              : "Integrate trackers, app, or sensors with guided onboarding."}
          </p>
        </div>
        <div className="step-card card-animated anim-card">
          <span className="step-index">02</span>
          <h3>{language === "es" ? "Configuras reglas" : "Configure rules"}</h3>
          <p>
            {language === "es"
              ? "Geocercas, alertas, formularios y roles por equipo."
              : "Geofences, alerts, forms, and team roles."}
          </p>
        </div>
        <div className="step-card card-animated anim-card">
          <span className="step-index">03</span>
          <h3>{language === "es" ? "Operas y auditas" : "Operate and audit"}</h3>
          <p>
            {language === "es"
              ? "Tableros, reportes y exportación para tomar decisiones."
              : "Dashboards, reports, and exports for decision-making."}
          </p>
        </div>
      </div>
    </div>
  </section>
);

export default HowItWorksSection;
